module.exports = __webpack_public_path__ + "static/don29-ec00bc46cd993de7a17fb2e50b8921a6.jpg";